import { useEffect, useState } from 'react';
import type { SiteInfo } from '../types';
import { siteInfoUrl, urlOrigin } from '../lib/urls';

interface Props {
  url: string;
  onClose: () => void;
}

export function SiteInfoPanel({ url, onClose }: Props) {
  const [info, setInfo] = useState<SiteInfo | undefined>();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setInfo(undefined); setError('');
    if (url.startsWith('websurf://')) {
      setInfo({ url, origin: 'WebSurf internal', secureConnection: true, certificate: { status: 'internal', explanation: 'Internal WebSurf pages are rendered locally.' }, permissions: { notifications: 'blocked', javascript: 'app controlled', popups: 'n/a', cookies: 'n/a' }, headers: {} });
      return;
    }
    fetch(siteInfoUrl(url))
      .then((response) => response.json() as Promise<SiteInfo>)
      .then((data) => { if (!cancelled) setInfo(data); })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Site info unavailable.'); });
    return () => { cancelled = true; };
  }, [url]);

  return (
    <div className="side-panel-backdrop" onClick={onClose}>
      <aside className="side-panel" onClick={(event) => event.stopPropagation()}>
        <header><div><p className="eyebrow">Site information</p><h2>{urlOrigin(url)}</h2></div><button onClick={onClose}>×</button></header>
        {!info && !error && <p>Loading site information…</p>}
        {error && <p className="helper-copy">{error}</p>}
        {info && (
          <div className="site-info-list">
            <div><strong>Secure connection</strong><span>{info.secureConnection ? 'Yes' : 'No'}</span></div>
            <div><strong>Certificate</strong><span>{info.certificate.status}</span><small>{info.certificate.explanation}</small></div>
            <div><strong>Status</strong><span>{info.status || 'n/a'}</span></div>
            <h3>Permissions</h3>
            {Object.entries(info.permissions).map(([key, value]) => <div key={key}><strong>{key}</strong><span>{value}</span></div>)}
            <h3>Response headers</h3>
            {Object.entries(info.headers).length === 0 && <p>No selected headers captured.</p>}
            {Object.entries(info.headers).map(([key, value]) => <div key={key}><strong>{key}</strong><code>{value}</code></div>)}
          </div>
        )}
      </aside>
    </div>
  );
}
